import { render, staticRenderFns } from "./WsInfoSwitch.vue?vue&type=template&id=cd8b9088&"
import script from "./WsInfoSwitch.vue?vue&type=script&lang=js&"
export * from "./WsInfoSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports